// 3rd party imports
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import * as _groupBy from 'lodash.groupby';

// bernie
import { AnalyticsStore, ContextStore, RouteStore } from 'bernie-core';

// shared-ui
import { ILocalization, LocalizedText, withLocalization } from '@shared-ui/localization-context';

// mobx
import { Program, ProgramRelationship, UserInfo } from 'models';
import { ProgramStore, UserAuthStore } from 'stores';

// ui
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkHeading } from 'uitk-react-text';

// components
import { ProgramCard } from './program-card/program-card';

interface ProgramsProps {
  analytics?: AnalyticsStore;
  context?: ContextStore;
  l10n?: ILocalization;
  programs?: ProgramStore;
  routeStore?: RouteStore;
  userAuth?: UserAuthStore;
  userInfo?: UserInfo;
  userPrograms?: ProgramRelationship[];
  groupBy?: string;
}

interface ProgramsState {
  programs: Program[];
  isMobile: boolean;
}

@withLocalization
@inject('analytics', 'context', 'programs', 'routeStore', 'userAuth')
@observer
export class Programs extends React.Component<ProgramsProps, ProgramsState> {
  public constructor(props) {
    super(props);

    this.state = {
      programs: [],
      isMobile: false,
    };
  }

  public componentDidMount() {
    const checkForMobileSize = window.screen.width <= 768;
    this.setState({ isMobile: checkForMobileSize });
    this.props.programs.getPrograms().then((data) => {
      const forcedLive = this.props.programs.forcedLive;
      if (forcedLive) {
        const index = data.findIndex((program) => program.name === forcedLive);
        if (index >= 0) {
          data[index].live = true;
        }
      }
      this.setState({
        programs: data,
      });
    });
  }

  private renderProgramCards(programs) {
    const { analytics, context, l10n, routeStore, userAuth, userInfo } = this.props;
    const { isMobile } = this.state;
    const userPrograms = userAuth.userProgramRelationships;

    let partnerId = null;
    let camref = null;
    let programStatus = null;

    const userId = userInfo && userInfo.email ? userInfo.email : null;
    const forcedLive = this.props.programs.forcedLive;

    return programs
      .filter((program) => program?.live !== false || forcedLive === program.name)
      .map((program) => {
        if (userPrograms && userPrograms.body.filter) {
          const candidateUserPrograms = userPrograms.body.filter((userProgram) => {
            return (
              userProgram.id.userId === userId &&
              userProgram.id.brand === program.brand &&
              userProgram.id.posa === program.posa
            );
          });

          if (candidateUserPrograms.length) {
            const userProgram = candidateUserPrograms[0];
            partnerId = userProgram.partnerIdentity.partnerId;
            camref = userProgram.programReference;
            programStatus = userProgram.affiliatePartnership.partnershipStatus;
          } else {
            partnerId = null;
            programStatus = null;
          }
        }

        return (
          <UitkLayoutGridItem key={program.name}>
            <ProgramCard
              analytics={analytics}
              context={context}
              l10n={l10n}
              program={program}
              partnerId={partnerId}
              camref={camref}
              programStatus={programStatus}
              routeStore={routeStore}
              user={userInfo}
              userAuth={userAuth}
              layout={isMobile ? 'card' : 'row'}
            />
          </UitkLayoutGridItem>
        );
      });
  }

  public render() {
    const { analytics, context, l10n, routeStore, userAuth, userInfo, groupBy } = this.props;
    const { programs, isMobile } = this.state;

    let programList = null;

    if (groupBy) {
      // split programs into groups that match groupBy
      const groups = _groupBy(programs, groupBy);
      programList = Object.keys(groups).map((group) => {
        const groupedPrograms = groups[group];
        const hasNoLivePrograms = groupedPrograms.every((program) => program.live === false);

        if (hasNoLivePrograms) {
          return;
        } else {
          return (
            <UitkSpacing margin={{ blockend: 'six' }} key={group}>
              <div>
                <UitkSpacing margin={{ blockend: 'six' }}>
                  <UitkHeading tag="h2" size={3}>
                    {groupBy === 'posa' ? (
                      <LocalizedText message={`programs.cards.group.heading.${group.toLowerCase()}`} />
                    ) : (
                      group
                    )}
                  </UitkHeading>
                </UitkSpacing>
                <UitkLayoutGrid space="four">{this.renderProgramCards(groupedPrograms)}</UitkLayoutGrid>
              </div>
            </UitkSpacing>
          );
        }
      });
    } else {
      // render in one big grid if no groupBy
      programList = <UitkLayoutGrid space="four">{this.renderProgramCards(programs)}</UitkLayoutGrid>;
    }

    return (
      <main className="container">
        <UitkSpacing margin={{ blockstart: 'four' }}>
          <>{programList}</>
        </UitkSpacing>
      </main>
    );
  }
}
